import {
  IssueAssembleResponse, Project, ProjectRole
} from '@issue-detail/components/IssueDrawer/Model/issue';
import { usePromise } from '@issue-detail/utils/usePromise';
import { useVuex } from '@issue-detail/utils/useVuex';
import { computed, ref, Ref, watch } from '@vue/composition-api';

import { getProjectRoles } from '../Api/issue';
import { ActionStore } from './action';
import { ShareStore, useShare } from './share';

export const useProject = (
  actionStore: ActionStore,
  issueAssemble: Ref<IssueAssembleResponse | null>,
  { isVisitor, shareProjectId, shareInfo }: ShareStore
) => {
  const vuex = useVuex();

  const currentProjectId = computed(() => {
    if (
      actionStore.action.value?.type === 'Create' ||
      actionStore.action.value?.type === 'PreviewType'
    ) {
      return actionStore.action.value.projectId;
    } if (actionStore.action.value?.type === 'Edit') {
      return issueAssemble.value?.issueVO?.projectId;
    }
  });

  const projectList = computed<Project[]>(() =>
    isVisitor.value
      ? [
        {
          id: shareProjectId.value!,
          pkey: shareInfo.value.pkey,
          pname: shareInfo.value.projectName,
          backgroundColor: '#FF8384'
        }
      ]
      : vuex.state.app.projectList
  );

  const currentProject = computed(() =>
    projectList.value.find((p) => p.id === currentProjectId.value)
  );

  const { result: projectRoles, refresh: refreshRoles } =
    usePromise(async () => {
      if (
        currentProjectId.value &&
        !vuex.getters.allRoles.some(
          (r: ProjectRole) => r.roleCode === 'anonymous'
        )
      ) {
        return await getProjectRoles(currentProjectId.value);
      }
      return [];
    }, []);

  watch(currentProjectId, refreshRoles, { immediate: true });

  return {
    projectList,
    currentProjectId,
    currentProject,
    projectRoles
  };
};

export type ProjectStore = ReturnType<typeof useProject>;
